/* eslint-disable react-hooks/exhaustive-deps */
import { useEffect, useState } from "react";
import { useRecoilState } from "recoil";

import AccessControl from "../functional/AccessControl";

import BasicCrudScreenActionItemLayout from "../screenTypes/layout/BasicCrudScreenActionItemLayout";
import BasicCrudScreenType from "../screenTypes/functional/BasicCrudScreenType";

import notificationState from "../../states/notificationState";

import getSchema from "../../lib/api/getSchema";

import { debounce } from "lodash";

import { Selector } from '@grapecity/wijmo.grid.selector';
import YearMonthDateRangeSelector from "../input/YearMonthDateRangeSelector";
import { useMemo } from "react";

import TkTotalAmountCalculationRefreshButton from "../input/TkTotalAmountCalculationRefreshButton";
import SaveToExcelButton from './../input/SaveToExcelButton';
import TkTotalAmounCalculationUpdateRecordButton from './../input/TkTotalAmounCalculationUpdateRecordButton';
import { ReflexContainer, ReflexElement, ReflexSplitter } from 'react-reflex';
import layoutConf from "../../config/layoutConf";
import TkTotalAmountCalculationAgreeButton from './../input/TkTotalAmountCalculationAgreeButton';
import TkTotalAmounCalculationconfirmCostUpdateRecordButton from './../input/TkTotalAmounCalculationconfirmCostUpdateRecordButton';

function TkTotalAmountCalculation(props) {

    const id = "TkTotalAmountCalculation";
    const table = "TkTotalAmountCalculation";
    const view = "TkVwTotalAmountCalculation";
    const detailView = "TkVwTotalAmountCalculationDetail";

    const [tableSchema, setTableSchema] = useState();
    const [editSchema, setEditSchema] = useState();
    const [grid, setGrid] = useState();
    // const [gridDetail, setGridDetail] = useState();
    const [api, setApi] = useState();
    const [apiDetail, setApiDetail] = useState();

    const [isEmpty, setIsEmpty] = useState();
    const [disableEdit, setDisableEdit] = useState(false);

    const [onSelectMst, setOnSelectMst] = useState([]);

    const [date,] = useState(new Date());

    const [from, setFrom] = useState();

    const [to, setTo] = useState();

    const [, setNotification] = useRecoilState(notificationState);

    const [, setSelector] = useState();

    const [height, setHeight] = useState(0);

    const handleResize = () => {
        setHeight(document.documentElement.offsetHeight - 96);
    };

    useEffect(() => {

        window.addEventListener("resize", handleResize);

        handleResize();

        return () => window.removeEventListener("resize", handleResize);

    }, []);

    useEffect(() => {
        let mounted = true;

        (async () => {

            let schema = await getSchema("TkVwTotalAmountCalculation");

            if (mounted) {

                setTableSchema(schema);

            }

        })();

        return (() => {

            mounted = false;

        });

    }, []);

    useEffect(() => {

        (async () => {

            if (grid) {

                grid.selectionChanged.addHandler(debounce((grid, event) => {

                    if (grid.selectedItems && grid.selectedItems[0]) {

                        // setOnSelectMst(grid.selectedItems[0]);

                        setOnSelectMst(grid.selectedItems);

                    }
                }), 10);

                grid.itemsSourceChanged.addHandler(debounce((grid, event) => {

                    if (grid.selectedItems && grid.selectedItems[0]) {

                        // setOnSelectMst(grid.selectedItems[0]);
                        setOnSelectMst(grid.selectedItems);
                    }
                }), 10);

                grid.formatItem.addHandler(function (s, e) {

                    if (e.panel === s.cells) {
                        let col = s.columns[e.col];

                        if (col.binding === 'totalCost') {
                            // let vnow = s.getCellData(e.row, e.col);

                            //셀 서식
                            // let html = `<div class="{cls}"><span >${vnow}</span></div>`;
                            // `<span style="font-size:120%" class="wj-glyph-{glyph}"></span>`;
                            // html = html.replace('{val}', format(diff, col.format));

                            if (!s.rows[e.row].dataItem["agreementFlag"]) {

                                // html = html.replace('{cls}', 'tkTotalAmountCalculation-cell-safeStock-many-qty');
                                e.cell.style.color = 'red';
                            }

                            // e.cell.innerHTML = html;
                        }
                    }
                });

            }
        })();

    }, [grid]);

    // useEffect(() => {

    //     (async () => {

    //         if (gridDetail) {

    //             gridDetail.formatItem.addHandler(function (grid, event) {
    //                 if (event.panel === grid.cells) {

    //                     let colName = grid.columns[event.col]?.binding;

    //                     const currentRow = event.row;
    //                     const compareRow = event.row ? 0 : 1
    //                     consoel
    //                     if (colName !== "factor" && grid.rows[currentRow].dataItem[colName] > grid.rows[compareRow].dataItem[colName]) {
    //                         event.cell.style.color = 'red';
    //                     } else {
    //                         event.cell.style.color = 'black';
    //                     }
    //                 }

    //                 // grid.row[compareRow].dataItem[]
    //                 //     if (e.panel === s.cells) {
    //                 //         let col = s.columns[e.col];

    //                 //         if (col.binding === 'totalCost') {
    //                 //             // let vnow = s.getCellData(e.row, e.col);

    //                 //             //셀 서식
    //                 //             // let html = `<div class="{cls}"><span >${vnow}</span></div>`;
    //                 //             // `<span style="font-size:120%" class="wj-glyph-{glyph}"></span>`;
    //                 //             // html = html.replace('{val}', format(diff, col.format));

    //                 //             if (!s.rows[e.row].dataItem["agreementFlag"]) {

    //                 //                 // html = html.replace('{cls}', 'tkTotalAmountCalculation-cell-safeStock-many-qty');
    //                 //                 e.cell.style.color = 'red';
    //                 //             }

    //                 //             // e.cell.innerHTML = html;
    //                 //         }
    //                 //     }
    //             });

    //         }
    //     })();

    // }, [gridDetail]);


    useEffect(() => {
        if (onSelectMst) {
            if (onSelectMst.length > 1) {
                setDisableEdit(true);
            } else {
                setDisableEdit(false);
            }
        }

        let mounted = true;

        (async () => {

            if (onSelectMst) {
                if (onSelectMst.length === 1) {
                    let editSchema = await getSchema("TkTotalAmountCalculation");

                    for (let column of editSchema.columns) {
                        if (column.name.includes("Cost")) {
                            column.formItemType = "autocompleteSolo";
                            column.codeInfo = {
                                tableName: `TkTotalAmountCalculation/autoComplete/${column.name}/${onSelectMst[0].orderBuyerDetailId}`,
                                nameColumn: ["factor", column.name],
                                valueColumn: column.name,
                                useEmptyValue: false,
                                sortByName: true,
                                seperator: ": ",
                                displayOnlyValue: true,
                                useTranslation: [true, false],
                            }
                        }


                    }

                    if (mounted) {

                        setEditSchema(editSchema)

                    }
                }
            }


        })();

        return (() => {

            mounted = false;

        });
    }, [onSelectMst])

    const onLoadData = (data) => {

        setIsEmpty(data.length < 1 ? true : false)

    };

    const onInitialized = (grid) => {
        grid.headersVisibility = "All";
        setSelector(new Selector(grid));
        setGrid(grid);

    };

    // const onInitializedDetail = (grid) => {

    //     setGridDetail(grid);

    // };

    const onApiInitialized = (api) => {

        setApi(api);

    };

    const onApiInitializedDetail = (api) => {

        setApiDetail(api);

    };

    const notifySuccess = (msg) => {
        setNotification({
            severity: "success",
            msg: msg,
            open: true,
        });
    };

    const onSuccess = (msg) => {
        if (api) {
            api.refresh();
        }
        notifySuccess(msg);
    };

    const notifyFailure = (msg) => {

        setNotification({
            severity: "error",
            msg: msg,
            open: true,
        });

    };

    const onFailure = (reason) => {

        notifyFailure(reason.response ? reason.response.data : reason);

    };

    const orderBuyerDetailIdList = useMemo(() => {
        let detailIdList = [];
        if (onSelectMst) {

            for (let item of onSelectMst) {
                detailIdList.push(item.orderBuyerDetailId)
            }
        }
        return detailIdList;
    }, [onSelectMst]);

    useEffect(() => {
        if (apiDetail) {
            apiDetail.refresh();
        }
    }, [onSelectMst, apiDetail]);

    const onAppendButtonInFrontOfSearch = () => {
        return (
            <>
                <BasicCrudScreenActionItemLayout>

                    <AccessControl
                        accessTarget={tableSchema && tableSchema.name}
                        accessMethod={
                            tableSchema && (tableSchema.updateWithPatch ? "PATCH" : "PUT")
                        }
                    >
                        <TkTotalAmountCalculationRefreshButton
                            id={"TkTotalAmountCalculation"}
                            schema={tableSchema}
                            grid={grid}
                            refresh={api}
                            disabled={onSelectMst?.approvalState ? true : false || isEmpty}
                            onSuccess={onSuccess}
                            detailList={orderBuyerDetailIdList}
                        />
                    </AccessControl>
                    <AccessControl accessTarget={tableSchema && tableSchema.name} accessMethod={tableSchema && (tableSchema.updateWithPatch ? "PATCH" : "PUT")}>
                        <TkTotalAmounCalculationUpdateRecordButton
                            id={id}
                            schema={editSchema}
                            grid={grid}
                            refresh={api}
                            disabled={isEmpty || disableEdit}
                            onSuccess={onSuccess}
                        />
                    </AccessControl>
                    <AccessControl accessTarget={tableSchema && tableSchema.name} accessMethod={tableSchema && (tableSchema.updateWithPatch ? "PATCH" : "PUT")}>
                        <TkTotalAmounCalculationconfirmCostUpdateRecordButton
                            id={id}
                            grid={grid}
                            refresh={api}
                            disabled={isEmpty || disableEdit}
                            onSuccess={onSuccess}
                        />
                    </AccessControl>
                    <AccessControl
                        accessTarget={tableSchema && tableSchema.name}
                        accessMethod={
                            tableSchema && (tableSchema.updateWithPatch ? "PATCH" : "PUT")
                        }
                    >
                        <TkTotalAmountCalculationAgreeButton
                            id={"TkTotalAmountCalculation"}
                            schema={tableSchema}
                            grid={grid}
                            refresh={api}
                            disabled={onSelectMst?.approvalState ? true : false || isEmpty}
                            onSuccess={onSuccess}
                            onFailure={onFailure}
                            agreementState={onSelectMst && onSelectMst[0]?.agreementState ? 'disagree' : 'agree'}
                            detailList={orderBuyerDetailIdList}
                        />
                    </AccessControl>
                    {/* <AccessControl
                        accessTarget={tableSchema && tableSchema.name}
                        accessMethod={
                            tableSchema && (tableSchema.updateWithPatch ? "PATCH" : "PUT")
                        }
                    >
                        <TkTotalAmountCalculationCAMButton
                            id={"TkTotalAmountCalculation"}
                            schema={tableSchema}
                            grid={grid}
                            refresh={api}
                            disabled={onSelectMst?.approvalState ? true : false || isEmpty || inputState}
                            onSuccess={onSuccess}
                            detailList={orderBuyerDetailIdList}
                        />
                    </AccessControl>

                    <AccessControl
                        accessTarget={tableSchema && tableSchema.name}
                        accessMethod={
                            tableSchema && (tableSchema.updateWithPatch ? "PATCH" : "PUT")
                        }
                    >
                        <TkTotalAmountCalculationEMButton
                            id={"TkTotalAmountCalculation"}
                            schema={tableSchema}
                            grid={grid}
                            refresh={api}
                            disabled={onSelectMst?.approvalState ? true : false || isEmpty || inputState}
                            onSuccess={onSuccess}
                            detailList={orderBuyerDetailIdList}
                        />
                    </AccessControl> */}
                    <AccessControl accessTarget={tableSchema && tableSchema.name} accessMethod="SAVETOEXCEL">
                        <SaveToExcelButton
                            id={id}
                            grid={grid}
                            view={view}
                            color="primary"
                            exportFormatItem={() => { }}
                            disabled={isEmpty}
                        />
                    </AccessControl>
                </BasicCrudScreenActionItemLayout>
            </>
        );
    };

    const onDateRangeChanged = (from, to) => {
        setFrom(from);
        setTo(to);

    }

    const toMonth = useMemo(() => {
        return new Date(date.getFullYear(), date.getMonth());
    }, [])

    const fromMonth = useMemo(() => {
        return new Date(date.getFullYear(), date.getMonth() - 1);
    }, [])


    const query = useMemo(() => {
        return { $from: from, $to: to }
    }, [from, to])

    const onModifyViewUrl = (url) => {

        url += `/preView/${onSelectMst[0]?.orderBuyerDetailId}`;

        return url;

    }

    return (
        <div style={{ height: height }}>

            <ReflexContainer orientation="horizontal">
                <ReflexElement minSize={3.7}>
                    <BasicCrudScreenType
                        id={id}
                        table={table}
                        view={view}
                        $queries={query}
                        noCreate
                        noEdit
                        noDelete
                        noExcel
                        buttonsInFrontOfSearch
                        onAppendHeaderAtFirst={() =>
                            <>
                                <YearMonthDateRangeSelector onChange={onDateRangeChanged}
                                    initFrom={fromMonth} initTo={toMonth}
                                />
                            </>
                        }
                        onLoadData={onLoadData}
                        onInitialized={onInitialized}
                        onApiInitialized={onApiInitialized}
                        onAppendButtonInFrontOfSearch={onAppendButtonInFrontOfSearch}
                        exportFormatItem={() => { }}
                    />
                </ReflexElement>
                <ReflexSplitter style={{ height: layoutConf.reflex.splitterHeight }} />
                <ReflexElement >
                    <BasicCrudScreenType
                        id={detailView}
                        table={detailView}
                        view={detailView}
                        noCreate
                        noEdit
                        noDelete
                        noExcel
                        noSearch
                        noFilter
                        noHeader
                        noPagination
                        // onInitialized={onInitializedDetail}
                        onApiInitialized={onApiInitializedDetail}
                        onModifyViewUrl={onModifyViewUrl}
                    />
                </ReflexElement>
            </ReflexContainer>
        </div >

    );
}

export default TkTotalAmountCalculation;
